/** The six views' names and charters, from `proto/cider-shell.js`. Items come from the registry. */
import type { ViewId } from '@cider/ui';

export const VIEW_META: Record<ViewId, { name: string; desc: string; charter: string }> = {
  volunteers: {
    name: 'VOLUNTEERS',
    desc: 'Shifts, signups, families, the booths',
    charter: 'Staffing by day, signups, the booths',
  },
  money: {
    name: 'MONEY',
    desc: 'Sales and Square, the budget, the books, the close',
    charter: 'The books, the bank, the close',
  },
  marketing: {
    name: 'MARKETING',
    desc: "What's on the boards and the site",
    charter: 'The boards, the site, the sponsors',
  },
  ops: {
    name: 'FESTIVAL OPS',
    desc: 'Watchtower, incidents, gates, grounds',
    charter: 'Watchtower, incidents, gates, grounds',
  },
  chairs: {
    name: 'CHAIRS',
    desc: 'The chair app — view as any chair',
    charter: 'Today, for one area',
  },
  admin: {
    name: 'FESTIVAL ADMIN',
    desc: 'Directors, the finance director, the volunteer chairs’ worklists',
    charter: 'Worklists, people, settings, system',
  },
};
